import { gql } from '@apollo/client';

export type CreateSupplierReferralLinkResponse = {
  createSupplierReferralLink: {
    referralLink: string;
  };
};

export const CREATE_SUPPLIER_REFERRAL_LINK = gql`
  mutation createSupplierReferralLink {
    createSupplierReferralLink {
      referralLink
    }
  }
`;
